export default __webpack_public_path__ + "static/media/lolMemoryGame.a72f37e7.png";